import React from 'react';
import {Helper} from "./Helper";

export default class POSCustomer extends React.Component {
	constructor() {
		super();
		this.state = {
			mode: false,
			payment: false,
			pos: window.localStorage.getItem('pos') && window.localStorage.getItem('pos') !== '' ? JSON.parse(window.localStorage.getItem('pos')) : false,
		}
	}

	componentDidMount() {
		window.$('.slide-menu-root').css({display: 'none'});
		window.$('.Wrapper_root').css({padding: 16});
		clearInterval(window.GetStore);
		window.GetStore = setInterval(() => {
			this.getStore();
		}, 2000);
	}

	componentWillUnmount() {
		clearInterval(window.GetStore);
	}

	getStore() {
		let payment = window.localStorage.getItem('payment') && window.localStorage.getItem('payment') !== '' ? JSON.parse(window.localStorage.getItem('payment')) : null;
		this.setState({
			payment: payment,
		}, () => {
			window.$(".itemsList").animate({scrollTop: window.$('.itemsList').prop("scrollHeight")}, 1000);
			// window.$("#Wrapper_root").animate({ scrollTop: window.$(document).height() }, 1000);
		})
	}

	render() {
		if (!this.state.payment) {
			return <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
				<h1 className={"ui header center-xs"} style={{fontSize: 70}}>ขอบคุณที่ใช้บริการ</h1>
			</div>;
		}
		let all_quantity = 0;
		this.state.payment.item.map((item) => {
			all_quantity += parseFloat(item._quantity);
			return null;
		});
		return (
			<div>
				<h1 className={"ui header"}>
					{this.state.pos ? this.state.pos.name : 'POS'}
				</h1>
				<div className="content">
					<div className={"flex row padded"}>
						<div className="col-lg-10 padded">
							<div className="flex row wrap">
								<div className="ui basic table Table_root td-top-xs" style={{marginTop: 0}}>
									<div className="thead">
										<div className="tr">
											<div className="th span10">สินค้า {this.state.payment.item.length} รายการ
												/ {all_quantity} ชิ้น
											</div>
											<div className="th span3">จำนวน</div>
											<div className="th span3">ราคา</div>
										</div>
									</div>
									<div className="tbody itemsList" style={{height: 600, overflowY: 'auto'}}>
										{
											this.state.payment.item.map((item, item_i) => {
												let calculate_item_price = Helper.CalculateItemPrice(item, {
													tax_type: this.state.payment.tax_type,
												});
												return (
													<div className="tr" key={item_i}>
														<div className={"td span10"}>
															<div className={"flex row middle-xs"}>
																<div style={{marginRight: 12}}>
																	<img className={"ui avatar image"}
																	     src={item.product.product_image_file_upload.url}
																	     alt={"ProductB49ERP"}
																	     style={{margin: 0}}
																	/>
																</div>
																<div style={{flex: 1}}>
																	<strong>{item.product.name}</strong>

																	<div>
																		<span style={{
																			color: calculate_item_price.discount === 0 ? '#02B04E' : null,
																			textDecoration: calculate_item_price.discount > 0 ? 'line-through' : null
																		}}>
																		{parseFloat(item.price).format(2)} บาท / {Helper.getRatioUnit(item.product, item.ratio).unit_name}
																		</span>
																	</div>
																	{
																		calculate_item_price.discount > 0 ?
																			<div>
																				<span style={{color: '#02B04E'}}>
																					{parseFloat(item.price) - parseFloat(calculate_item_price.discount_amount / item._quantity).format(2)} บาท
																					/
																					{Helper.getRatioUnit(item.product, item.ratio).unit_name}
																				</span>
																				<label className={"ui label red small"}
																				       style={{marginLeft: 5}}>
																					ลด
																					{
																						calculate_item_price.discount
																					}
																					{
																						calculate_item_price.discount_type === '%' ?
																							calculate_item_price.discount_type
																							: 'บาท'
																					}
																				</label>
																			</div>
																			: null
																	}
																</div>
															</div>
														</div>
														<div className={"td span3"}>
															{item._quantity} {Helper.getRatioUnit(item.product, item.ratio).unit_name}
														</div>
														<div className={"td span3"}>
															{calculate_item_price.total_price.format(2)} บาท
														</div>
													</div>
												)
											})
										}
									</div>
								</div>
							</div>


						</div>
						<div className={"col-lg-6 padded"}>
							<div className={"stciky-segment"}>
								<div className="ui segment">
									<div className={"flex row middle-xs"}>
										<div><strong>รวมมูลค่าสินค้า</strong></div>
										<div className={"right floated"}>
											{Helper.calculateSummary(this.state.payment, this.state.payment.item).total_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs"} style={{marginTop: 10}}>
										<div>
											<strong>ภาษีมูลค่าเพิ่ม {Helper.calculateSummary(this.state.payment, this.state.payment.item).tax}%</strong>
										</div>
										<div className={"right floated"}>
											{Helper.calculateSummary(this.state.payment, this.state.payment.item).total_tax_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs"} style={{marginTop: 10}}>
										<div><strong>ราคาไม่รวมภาษีมูลค่าเพิ่ม</strong></div>
										<div className={"right floated"}>
											{Helper.calculateSummary(this.state.payment, this.state.payment.item).total_price_exclude_vat.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs"} style={{marginTop: 10}}>
										<div><strong>จำนวนเงินรวมทั้งสิ้น</strong></div>
										<div className={"right floated"}>
											{Helper.calculateSummary(this.state.payment, this.state.payment.item).total_net_price_without_withholding_tax.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
								</div>
								<div className={"ui segment"} style={{lineHeight: 1}}>
									<div className={"flex row middle-xs"} style={{fontSize: 30}}>
										<div><strong>ยอดชำระ</strong></div>
										<div className={"right floated"}>
											{Helper.calculateSummary(this.state.payment, this.state.payment.item).total_net_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									{
										this.state.payment.payment.length > 0 ?
											<div className="ui divider"/>
											: null
									}
									{
									this.state.payment.payment.map((payment_by, payment_by_key) => {
										if (payment_by.payment_by === 'cash'
											&& payment_by.price > 0
										) {
											return (
												<div key={payment_by_key}>
													<div className={"flex row middle-xs"}
													     style={{fontSize: 26}}>
														<div><strong>เงินสด</strong></div>
														<div className={"right floated"}>
															{payment_by.price.format(2, 3, {pretty: false})} บาท
														</div>
													</div>
													<div className={"flex row middle-xs"}
													     style={{marginTop: 10, fontSize: 26}}>
														<div><strong>รับเงิน</strong></div>
														<div className={"right floated"}>
															{payment_by.payment_by_cash_pos.receive_amount.format(2, 3, {pretty: false})} บาท
														</div>
													</div>
													<div className={"flex row middle-xs"}
													     style={{marginTop: 10, fontSize: 26}}>
														<div><strong>เงินทอน</strong></div>
														<div className={"right floated"}>
															{payment_by.payment_by_cash_pos.change_amount.format(2, 3, {pretty: false})} บาท
														</div>
													</div>
												</div>
											);
										}
										if (payment_by.payment_by === 'bank_transfer'
											&& parseFloat(payment_by.price) > 0
										) {
											return (
												<div className={"flex row middle-xs"}
												     style={{marginTop: 10, fontSize: 26}}
												     key={payment_by_key}>
													<div><strong>โอนเงิน</strong></div>
													<div className={"right floated"}>
														{payment_by.price.format(2, 3, {pretty: false})} บาท
													</div>
												</div>
											);
										}
										return null;
									})
								}
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}